module.exports = __webpack_public_path__ + "static/media/nato_strap_black_white.63463eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nato_strap_black_white.png
// module id = 113
// module chunks = 0